export default "__VITE_ASSET__CZNUNdPC__"